import { ensureUserIsLoggedIn } from "scrivito"
import { fetchLoginURL } from "shared/lib/auth/fetchLoginURL"
import { redirect } from "shared/lib/redirect"
import { useEvent } from "shared/lib/useEvent"

import I18n from "i18n"

interface LoginOptions {
  redirectURL?: string
}

export function useLoginWithIDP() {
  const loginWithIDP = useEvent((idp: string, options?: LoginOptions) => {
    fetchLoginURL().then(url => {
      if (url) {
        const resolvedURL = url
          ?.replace("$JR_AUTH_LOCATION", `${window.location.origin}/auth`)
          .replace("$RETURN_TO", options?.redirectURL || window.location.href)
        redirect(
          `${resolvedURL}&idp=${encodeURIComponent(
            idp
          )}&ignore_expired_session=true&lang=${I18n.language}`
        )
      } else {
        ensureUserIsLoggedIn({ idp })
      }
    })
  })

  const handleLoginAsEmployee = useEvent((options?: LoginOptions) =>
    loginWithIDP(import.meta.env.VITE_SCHAKO_IDP_URL, options)
  )

  const handleLoginAsVisitor = useEvent((options?: LoginOptions) =>
    loginWithIDP(import.meta.env.VITE_VISITOR_IDP_URL, options)
  )

  return {
    loginAsEmployee:
      import.meta.env.VITE_SCHAKO_IDP_URL !== "__NONE__"
        ? handleLoginAsEmployee
        : undefined,
    loginAsVisitor:
      import.meta.env.VITE_VISITOR_IDP_URL !== "__NONE__"
        ? handleLoginAsVisitor
        : undefined
  }
}
